import $ from 'jquery';
import slick from 'slick-carousel';
export default () => {
    var HeroBannerSliderController = (function () {
        var initSlider = function () {
            let slider = null;
            let slidingAutoplayDelayMs = 5000;
            let isRtl = $("html").attr("dir") === "rtl";

            $("[data-hbslider]").each(function () {
                slider = $(this);
                let autoPlay;
                let autoPlayValue = slider.attr('data-autoplay');
                if (autoPlayValue == "false") {
                    autoPlay = false;
                }
                else {
                    autoPlay = true;
                }

                let defaultOptions = {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    autoplaySpeed: slidingAutoplayDelayMs,
                    autoplay: autoPlay,
                    fade: true,
                    cssEase: 'linear',
                    accessibility: true,
                    rtl :isRtl
                };

                slider.slick(defaultOptions);

            });
        };

        var init = function () {
            if ($("[data-hbslider]").length <= 0) {
                return;
            }

            initSlider();
        };

        return {
            init: init
        };
    })();
    $(function () {
        HeroBannerSliderController.init();
    });

};
